import { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { blogPosts, blogCategories } from '../../mocks/blog';

const BlogPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('Tümü');
  const [headerRef, headerInView] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [postsRef, postsInView] = useInView({ triggerOnce: true, threshold: 0.1 });

  const filteredPosts = selectedCategory === 'Tümü'
    ? blogPosts
    : blogPosts.filter(post => post.category === selectedCategory);

  return (
    <div className="min-h-screen bg-cream-light pb-16 lg:pb-0">
      <Header />

      {/* Header Section */}
      <motion.section
        ref={headerRef}
        initial={{ opacity: 0, y: 30 }}
        animate={headerInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.8 }}
        className="pt-32 pb-12"
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end mb-8">
            <div>
              <h1 className="font-serif text-4xl lg:text-6xl font-bold text-navy mb-4">
                BLOG
              </h1>
              <p className="font-sans text-lg text-gray-600">
                Liderlik, strateji ve kişisel gelişim üzerine düşünceler
              </p>
            </div>

            {/* Category Dropdown */}
            <div className="mt-6 lg:mt-0">
              <select
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
                className="font-sans text-sm bg-white border border-gray-300 text-navy px-4 py-2.5 rounded-lg focus:outline-none focus:border-gold transition-colors duration-300 cursor-pointer"
              >
                {blogCategories.map((category) => (
                  <option key={category} value={category}>
                    {category}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </motion.section>

      {/* Blog Grid */}
      <motion.section
        ref={postsRef}
        initial={{ opacity: 0, y: 50 }}
        animate={postsInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.8 }}
        className="pb-20"
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredPosts.map((post, index) => (
              <motion.div
                key={post.id}
                initial={{ opacity: 0, y: 30 }}
                animate={postsInView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.6, delay: index * 0.1 }}
              >
                <Link
                  to={`/blog/${post.slug}`}
                  className="block bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden group cursor-pointer hover:-translate-y-1"
                >
                  <div className="relative h-60 overflow-hidden">
                    <img
                      src={post.coverImage}
                      alt={post.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-7">
                    <span className="font-sans text-xs text-gold uppercase tracking-wider">
                      {post.category}
                    </span>
                    <h2 className="font-serif text-xl font-bold text-navy mt-2 mb-2 line-clamp-2 leading-snug">
                      {post.title}
                    </h2>
                    <p className="font-sans text-sm text-gray-500 mb-3">{post.date}</p>
                    <p className="font-sans text-base text-gray-600 line-clamp-3 leading-relaxed mb-3">
                      {post.excerpt}
                    </p>
                    <p className="font-sans text-xs text-gray-400 mb-4">{post.readTime} okuma</p>
                    <span className="font-sans text-sm font-medium text-gold group-hover:text-gold-light transition-colors duration-300">
                      Devamını Oku →
                    </span>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.section>

      <Footer />
    </div>
  );
};

export default BlogPage;